"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _clsx5 = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _commonHorizontalList = _interopRequireDefault(require("../styles/common-horizontal-list.css"));
var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DropdownMenu, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  DropdownMenu.resourceType = function resourceType() {
    return 'DropdownMenu_1_0_0';
  };
  function DropdownMenu(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    _this.setIsOpen = _this.setIsOpen.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  DropdownMenu.getSelectedIndex = function getSelectedIndex(sectionLinks) {
    return sectionLinks.findIndex(function (item) {
      return item.selected === true;
    });
  };
  DropdownMenu.getOverviewText = function getOverviewText(overviewText, sectionLinks) {
    var index = DropdownMenu.getSelectedIndex(sectionLinks);
    if (index > -1 && index !== 0 || (0, _isEmpty["default"])(overviewText)) return sectionLinks[index] ? sectionLinks[index].label : '';
    if (!(0, _isEmpty["default"])(overviewText)) return overviewText;
    return null;
  };
  var _proto = DropdownMenu.prototype;
  _proto.setIsOpen = function setIsOpen(isOpen) {
    this.setState({
      isOpen: isOpen
    });
    var onDropdownToggle = this.props.onDropdownToggle;
    onDropdownToggle(isOpen);
  };
  _proto.render = function render() {
    var _clsx,
      _this2 = this,
      _clsx2,
      _clsx3;
    var _this$props = this.props,
      items = _this$props.items,
      getCTAData = _this$props.getCTAData,
      theme = _this$props.theme,
      overviewText = _this$props.overviewText;
    var isOpen = this.state.isOpen;
    if (items.length === 0) return null;
    var first = items[0];
    var parentItemData = getCTAData(first);
    var dropdownButtonText = DropdownMenu.getOverviewText(overviewText, items);
    var isDropdownButtonTruncated = (dropdownButtonText == null ? void 0 : dropdownButtonText.length) > 9;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonHorizontalList["default"].dropdownMenuWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonHorizontalList["default"].dropdownMenuHead
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonHorizontalList["default"].dropdownMenuTitle
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      key: parentItemData.url,
      data: parentItemData,
      theme: theme,
      classes: _commonHorizontalList["default"].dropdownCtaClasses,
      spanClasses: _commonHorizontalList["default"].dropdownCtaWrapperClasses
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonHorizontalList["default"].dropdownMenuRight
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx5["default"])(_commonHorizontalList["default"].dropdownNavButton, (_clsx = {}, _clsx[theme.mmcIconChevronUp] = isOpen, _clsx[theme.mmcIconChevronDown] = !isOpen, _clsx[_commonHorizontalList["default"].lightIcon] = !isOpen, _clsx)),
      type: "button",
      onClick: function onClick() {
        return _this2.setIsOpen(!isOpen);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx5["default"])((_clsx2 = {}, _clsx2[_commonHorizontalList["default"].dropdownOverviewTextActive] = isOpen, _clsx2[_commonHorizontalList["default"].isTruncated] = isDropdownButtonTruncated, _clsx2))
    }, dropdownButtonText)))), /*#__PURE__*/_react["default"].createElement("div", {
      "aria-expanded": isOpen,
      className: (0, _clsx5["default"])(_commonHorizontalList["default"].dropdownMenuItems, (_clsx3 = {}, _clsx3[_commonHorizontalList["default"].active] = isOpen, _clsx3))
    }, items.map(function (item, index) {
      var _clsx4;
      var data = getCTAData(item);
      if (index === 0 && !(0, _isEmpty["default"])(overviewText)) {
        data.label = overviewText;
      }
      if (item.selected) {
        data.url = null;
      }
      return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        key: item.url,
        data: data,
        theme: theme,
        classes: _commonHorizontalList["default"].dropdownCtaClasses,
        spanClasses: (0, _clsx5["default"])(_commonHorizontalList["default"].dropdownCtaWrapperClasses, (_clsx4 = {}, _clsx4[_commonHorizontalList["default"].dropdownCtaClasses90] = !item.selected, _clsx4[_commonHorizontalList["default"].dropdownCtaActive] = item.selected, _clsx4))
      });
    })));
  };
  return DropdownMenu;
}(_react["default"].Component);
exports["default"] = DropdownMenu;
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = {
  overviewText: ''
};